module.exports = __webpack_public_path__ + "media/images/pic/brodno/offer/team-5dcd10ea25172d86db53ee8f2950f49f.jpg";